<template>
  <div class="relative">
    <vue-feather
      type="search"
      class="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
    />
    <Input v-model="model" :placeholder="placeholder" class="pl-9" />
  </div>
</template>

<script setup lang="ts">
import { Input } from '@/components/ui/input';
import { useVModel } from '@vueuse/core';

const props = withDefaults(defineProps<{ modelValue: string; placeholder?: string }>(), { placeholder: 'Search' });
const emit = defineEmits<{ 'update:modelValue': [value: string] }>();
const model = useVModel(props, 'modelValue', emit);
</script>
